export const Sources = {
  TPREK: 'tprek',
  LINKED: 'linked',
} as const;

export const HELSINKI_OCD_DIVISION_ID =
  'ocd-division/country:fi/kunta:helsinki' as const;
